import { toast as _toast } from "sonner";

// Centralised duration defaults.
// Per-call { duration } overrides these values.
function toast(msg, opts) {
  return _toast(msg, opts);
}

toast.success = (msg, opts) => _toast.success(msg, { duration: 2000, ...opts });
toast.error   = (msg, opts) => _toast.error(msg,   { duration: 4000, ...opts });
toast.info    = (msg, opts) => _toast.info(msg,    { duration: 2000, ...opts });
toast.warning = (msg, opts) => _toast.warning(msg, { duration: 3000, ...opts });

toast.dismiss = _toast.dismiss;
toast.promise = _toast.promise;
toast.loading = _toast.loading;
toast.custom  = _toast.custom;
toast.message = _toast.message;

export { toast };
